<template>
  <v-dialog
    :value="value"
    max-width="600"
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card class="pb-5">
      <v-toolbar
        width="100%"
        class="px-5"
        color="transparent"
        flat
      >
        <v-toolbar-title>
          {{ modalTitle }}
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-row
        no-gutters
        class="mt-5 mx-5"
      >
        <v-col
          cols="12"
          md="6"
          class="px-5"
          @scroll.stop
        >
          <VSelect
            v-model="widthSelected"
            :items="widthItems"
            :label="widthLabel"
            :placeholder="widthPlaceholder"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="px-5"
          @scroll.stop
        >
          <VSelect
            v-model="heightSelected"
            :items="heightItems"
            :label="heightLabel"
            :placeholder="heightPlaceholder"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { HEIGHT, WIDTH, WIDTH_SIZE_LABEL, HEIGHT_SIZE_LABEL } from '@/store/modules/cards/constants';

export default {
  name: 'ResizeModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      modalTitle: 'Redimensionar componente',
      widthLabel: 'Largura',
      widthPlaceholder: 'Default',
      heightLabel: 'Altura',
      heightPlaceholder: 'Default',
    };
  },
  computed: {
    widthItems() {
      return Object.keys(WIDTH).map(sizeName => {
        return {
          text: WIDTH_SIZE_LABEL[sizeName],
          value: WIDTH[sizeName],
        };
      });
    },
    widthSelected: {
      get() {
        return this.widthItems.find(widthObj => widthObj.value === this.width);
      },
      set(newValue) {
        this.$emit('input', false);
        this.$emit('resize-width', newValue);
      },
    },
    heightItems() {
      return Object.keys(HEIGHT).filter(sizeName => sizeName !== HEIGHT.AUTO.toUpperCase()).map(sizeName => {
        return {
          text: HEIGHT_SIZE_LABEL[sizeName],
          value: HEIGHT[sizeName],
        };
      });
    },
    heightSelected: {
      get() {
        return this.heightItems.find(heightObj => heightObj.value === this.height);
      },
      set(newValue) {
        this.$emit('input', false);
        this.$emit('resize-height', newValue);
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
